var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileNavFindAStore = function SvgMobileNavFindAStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mobile-nav-find-a-store_svg__a",
    d: "M0 0h44v44H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mobile-nav-find-a-store_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mobile-nav-find-a-store_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.5,
    mask: "url(#mobile-nav-find-a-store_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M14.196 10h14.91c.933 0 1.781.54 2.177 1.385Q34 17.227 34 18.931c0 1.898-1.048 3.987-3.97 3.987q-2.92 0-4.149-2.349-2.176 2.35-4.162 2.35-1.987 0-3.886-2.35-.92 2.35-4.433 2.35c-3.513 0-4.4-2.123-4.4-3.988q0-1.686 3.063-7.63A2.4 2.4 0 0 1 14.196 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M13.042 17.34h16.692"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.228 24.939V32h20.827v-7.061"
  })))));
};
export default SvgMobileNavFindAStore;